import { notification, message } from 'antd'
import { RootState } from '../redux/store'
import { useSelector } from 'react-redux'
import * as queryString from 'query-string'
import { balanceOfdebtType } from '../constants/balanceOfdebtConstants'
import moment from 'moment'
export function showNoti(type: 'success' | 'error' | 'warning' | 'info', text: string) {
  notification[type]({
    message: 'Thông báo',
    description: text,
  })
}

export function showMessage(type: 'info' | 'success' | 'error' | 'warning' | 'loading', text: string) {
  message[type](text, 4.5)
}

export function isEmailValid(email: string) {
  let re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export function isPhoneValid(phone: string) {
  try {
    const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()
    const phoneNumber = phoneUtil.parse(phone, 'VN')
    return phoneUtil.isValidNumber(phoneNumber, 'VN')
  } catch (e) {
    return false
  }
}

export function handleError(err: any) {
  if (err.message) showMessage('error', err.message + ' (' + err.code + ')')
  else {
    console.error(err)
  }
}

export function getBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

export function showPrice(price: number | undefined) {
  4
  if (price == undefined) return ""
  return Number(price).toLocaleString('en-US', { maximumFractionDigits: 6, useGrouping: true })
}

export function numberExcel(price: number | undefined) {
  if (price == undefined) return ""
  
  // Format the number as a string
  const formattedNumber = Number(price).toLocaleString('en-US', {
    maximumFractionDigits: 6,
    useGrouping: true,
  });

  // Replace '.' with ',' and ',' with '.'
  const result = formattedNumber.replace(/\./g, '@').replace(/,/g, '.').replace(/@/g, ',');

  return result;
}

export function convertGender(gender: number) {
  if (gender === 1) return 'Nam'
  if (gender === 2) return 'Nữ'
  return ''
}

export const renderFormula = (formula: string) => {
  switch (formula) {
    case 'compare_kg_and_m3':
      return 'So sánh giá'
    case 'per_kg':
      return 'Theo cân nặng (kg)'
    case 'per_m3':
      return 'Theo thể tích (m3)'
    default:
      return ''
  }
}

export const renderExportImportService = (exportImportService: string) => {
  switch (exportImportService) {
    case 'container_consolidation':
      return 'Gom container'
    case 'full_container':
      return 'Full container'
    default:
      return 'Chưa cấu hình'
  }
}

export const handleChangePaging = ({
  history,
  pathname,
  search,
  page,
  pageSize,
}: {
  history: any
  pathname: string
  search: string
  page: number
  pageSize?: number
}) => {
  const parsed: any = queryString.parse(search)
  parsed.page = page
  if (pageSize) parsed.page_size = pageSize
  const stringified = queryString.stringify(parsed, { skipEmptyString: true })
  history.push(pathname + '?' + stringified)
}


export function formatter(value: number | undefined) {
  return Number(value).toLocaleString('en-US', { maximumFractionDigits: 6, useGrouping: true })
}



export function formatterSoKhoi(value: number | undefined) {
  return Number(value).toLocaleString('en-US', { maximumFractionDigits: 6, useGrouping: true })
}

export const formatterNumber = (val) => {
  if (!val) return 0;
  return `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/\.(?=\d{0,2}$)/g, ",");
}


export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const openInTab = (url: string) => {
  window.open(url, "_self");
};

export const delay = async (value: number) => {
  await new Promise(resolve => setTimeout(resolve, value));
};

// Hàm kiểm tra quyền Clipboard
export async function requestClipboardPermission(): Promise<boolean> {
  try {
    const permissionStatus = await navigator.permissions.query({ name: "clipboard-write" as any });

    if (permissionStatus.state === "granted" || permissionStatus.state === "prompt") {
      console.log("Quyền clipboard đã được cấp hoặc có thể yêu cầu.");
      return true;
    } else {
      console.error("Quyền clipboard bị từ chối.");
      return false;
    }
  } catch (error) {
    console.error("Không thể kiểm tra quyền clipboard:", error);
    return false;
  }
}

// Hàm sao chép văn bản
export async function copyToClipboardWithPermission(text: string): Promise<void> {
  const hasPermission = await requestClipboardPermission();
  if (hasPermission) {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Văn bản đã được sao chép thành công!");
    } catch (error) {
      console.error("Không thể sao chép văn bản:", error);
    }
  } else {
    console.error("Không có quyền truy cập Clipboard.");
  }
}

// Gọi hàm sao chép
export async function handleCopy() {
  await copyToClipboardWithPermission("Nội dung cần sao chép");
}


export const getTransProviderById = (nccVanChuyenId: number) => {
  const transProviderList = useSelector((state: RootState) => state.transProvider.transProviderList || {})
  let nccVanChuyenTen = nccVanChuyenId
  if (Array.isArray(transProviderList.data) && transProviderList.data.length > 0) {
    transProviderList.data.map((item: any) => {
      if (item.id) {
        nccVanChuyenTen = item.ten
      }
    })
  }
  return nccVanChuyenTen
}

export const convertLoaiDoiTuong = (loaiDoiTuong: string) => {
  switch (loaiDoiTuong) {
    case balanceOfdebtType.NCC_THUCTE:
      return "CN NCC thực tế"
    case balanceOfdebtType.NCC_NGAYPHATHANGTHUCTE:
      return "CN NCC theo ngày phát hàng thực tế"
    case balanceOfdebtType.NCC_NGAYDATHANGTHUCTE:
      return "CN NCC theo ngày đặt hàng thực tế"
    case balanceOfdebtType.NCCVC:
      return "Công nợ vận chuyển"
    case balanceOfdebtType.NCCTIENTE:
      return "Công nợ thanh toán"
    default:
      return ""
  }
}


export const isHaveValue = (value: any) => {
  return value != null && value != "" && value != undefined
}

export const fomartDateTime = (date: string | Date) => {
  return date ? moment(date).format('DD/MM/YYYY | HH:mm') : ''
}


